import React from "react";
import Slider, { Settings } from "react-slick";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import CardCarouselCard, { CardCarouselCardProps } from "./CardCarouselCard.blok";
import "../../../styles/carousel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface CardCarouselProps extends Blok {
  title?: string;
  description?: string;
  is_carousel?: boolean;
  cards?: CardCarouselCardProps[];
}

const getSliderSettings = (cardCount: number): Settings => ({
  dots: false,
  arrows: false,
  infinite: cardCount > 4,
  autoplay: cardCount > 4,
  autoplaySpeed: 4000,
  pauseOnHover: false,
  pauseOnFocus: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1280, settings: { slidesToShow: 3 } },
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 640, settings: { slidesToShow: 1 } },
  ],
});

const CardCarousel: React.FC<CardCarouselProps> = ({ title, description, is_carousel = false, cards = [] }) => {
  return (
    <div className="overflow-hidden bg-Primary-50">
      <div className="container mx-auto py-12 md:py-16 lg:py-20">
        {(title || description) && (
          <div className="mb-8 md:mb-10">
            {title && <h4 className="text-[22px] font-bold leading-[30px] text-SP6">{title}</h4>}
            {description && <p className="mt-4 text-[16px] font-normal leading-[28px] text-Body">{description}</p>}
          </div>
        )}

        {!!cards.length &&
          (is_carousel ? (
            <Slider {...getSliderSettings(cards.length)} className="card-carousel card-carousel--overflow -mx-3">
              {cards.map((card: CardCarouselCardProps, index: number) => (
                <div key={card._uid ?? `card-carousel-card--${index + 1}`} className="h-full px-3">
                  <CardCarouselCard {...card} />
                </div>
              ))}
            </Slider>
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {cards.map((card: CardCarouselCardProps, index: number) => (
                <CardCarouselCard key={card._uid ?? `card-carousel-card--${index + 1}`} {...card} />
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default CardCarousel;
